import React from 'react';
import { useTranslation } from 'react-i18next';
import X from '../../icons/x.svg';

type InputClearButtonProps = {
	onClick: () => void;
	isVisible: boolean;
}

export const InputClearButton = ({ onClick, isVisible }: InputClearButtonProps) => {
	const { t } = useTranslation();

	return (
		<button
			className={`InputClearButton ${!isVisible ? 'InputClearButton--hidden' : ''}`}
			onClick={onClick}
			onKeyDown={(event) => ['Enter', ' '].includes(event.key) && onClick()}
			tabIndex={0}
			aria-label={t('aria.clear_text_field_button')}
		>
			<img
				src={X}
				alt={t('aria.clear_input_field_icon')}
			/>
		</button>
	);
};